// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import artistes from './routes/artistes';
import cjm from './routes/cjm';
import common from './routes/common';
import home from './routes/home';
import Router from './util/Router';
import single from './routes/single';
import singleEvenement from './routes/singleEvenement';
import singleSondage from './routes/singleSondage';
import singleJob from './routes/singleJob';
import templateActualites from './routes/actualites';
import templateAgenda from './routes/agenda';
import templateDevenirMembre from './routes/devenirMembre';
import templateFaq from './routes/faq';
import templateInterventionsParlementaires from './routes/interventionsParlementaires';
import templateJobs from './routes/jobs';
import templateMagazine from './routes/magazine';
import templateNosRepresentants from './routes/nosRepresentants';
import templateParti from './routes/leParti';

/** Populate Router instance with DOM routes */
const routes = new Router({
  artistes,
  cjm,
  // All pages
  common,
  home,
  single,
  singleEvenement,
  singleSondage,
  singleJob,
  templateActualites,
  templateAgenda,
  templateDevenirMembre,
  templateFaq,
  templateInterventionsParlementaires,
  templateJobs,
  templateParti,
  templateMagazine,
  templateNosRepresentants,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
